import { nonFalsey } from '@/utils/nonFalsey';

interface UserWithNames {
  title?: string | null | undefined;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
}

export const getUserName = (
  user: UserWithNames | null | undefined,
  includeTitle?: boolean,
) => {
  const { title, firstName, lastName } = user ?? {};

  const namesArray = includeTitle
    ? [title, firstName, lastName]
    : [firstName, lastName];

  return namesArray.filter(nonFalsey).join(' ');
};

export const getUserDisplayName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  fallback = 'Unknown',
) => [firstName, lastName].filter(nonFalsey).join(' ') || fallback;
